import { createStore } from "vuex"
import Vue from 'vue'
import Vuex from 'vuex'

const store = createStore({
    state: {
        user: null,
        movie: null,
        music: null,
        book: null,
        questionary: null,
        course: null,
        popularization: null,
        memberId: null,
        testUserId: null,
    },

    mutations: {
        updateAdmin(state, user){
            state.user = user
        },
        updateAdminName(state, userName){
            state.userName = userName
        },
        updateMovie(state, movie){
            state.movie = movie
        },
        updateMusic(state, music){
            state.music = music
        },
        updateBook(state, book){
            state.book = book
        },
        updateQuestionary(state, questionary){
            state.questionary = questionary
        },
        updateCourse(state, course){
            state.course = course
        },
        updatePopularization(state, popularization){
            state.popularization = popularization
        },
        updateArticle(state, article){
            state.article = article
        },
        updateSchool(state, school){
            state.school = school
        },
        updateClass(state, classInfo){
            state.classInfo = classInfo
        },
        updateMemberId(state, id){
            state.memberId = id
        },
        updateTestUserId(state, id){
            state.testUserId = id
        },
        logout(state){
            state.user = null
        }
    }
})

if (localStorage.getItem('vuex')) {
    store.replaceState(Object.assign({}, store.state, JSON.parse(localStorage.getItem('vuex'))));
}

// 在页面卸载时保存状态
window.addEventListener('beforeunload', () => {
    localStorage.setItem('vuex', JSON.stringify(store.state));
});

export default store